import React, { useEffect, useContext, useMemo } from "react";
import { useMediaQuery } from "react-responsive";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
//import "../../../LearningResources/styles/Assesment.css";
//import "./TestCharts.css";
import { makeStyles } from "@material-ui/core/styles";
import MiniCards, { getLabel } from "./MiniCards";
import { useHistory } from "react-router-dom";
import Table from "./Table/Table";
import TimePerSubject from "./Charts/Time_Per_Subject/Time_Per_Subject";


import LearningStrength from "./Charts/LearningStrength";
import TestStatusPieChart from "./Charts/TestStatusPieReport";
import ResourceWiseQuestionAttemptAnalysis from "./Charts/ResourceWiseQuestionAttemptAnalysis";
import OverallQuestionAttemptAnalysis from "./Charts/OverallQuestionAttemptAnalysis";
import CognitiveReport from "./Charts/CognitiveReport";
import DifficultyReport from "./Charts/DifficultyReport";
import TestStatus from "./Charts/TestStatus";

import SideBoard from "../../SideBoard/SideBoard";
import Grid from "@material-ui/core/Grid";
// import { Link } from "react-router-dom";
import Buttons from "../../Table/Buttons/Buttons";
import TrendingFlatIcon from "@material-ui/icons/TrendingFlat";
import {
  overAllAnalytics,
  FilterBySubject,
  FilterByChapter,
  FilterByTopic,
} from "../../../../Api/OnlineTest";
import { GlobalContext } from "../../../../context/GlobalState";
import DifficultyChart from "./Charts/Difficulty_Report/DifficultyChart";

import { OnlineTest } from "./OnlineTests/TableHeader";
import TableComponent from "./OnlineTests/Table";
import TestFilter from "../TestFilter/TestFilter";

import axios from "axios";
import AnalyticsHeader from "../../components/AnalyticsHeader";
import AnalyticsSection from "../../components/AnalyticsSection";
import { ScrollTop } from "../../../../shared/ui/ScrollTop";
import { OnlineTestLists } from "./OnlineTests/OnlineTestLists";
import AnalyticsGrid from "../../components/AnalyticsGrid";
import { getHours } from "../../utils/time";

const useStyles = makeStyles({
  graphContainer: {
    width: "100%",
    height: "500px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  linkContainer: {
    marginTop: "50px",
    width: "100%",
    textAlign: "center",
    "& a": {
      background: "rgba(86, 229, 143, 0.9)",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      borderRadius: "5px",
      color: "black",
      textDecoration: "none",
      padding: "5px",
    },
  },
  "@media screen and (max-width: 768px)": {
    graphContainer: {
      flexDirection: "column",
      height: "100%",
      width: "100%",
      marginTop: "1rem",
      "& > *": {
        marginBottom: "1rem",
      },
    },
    linkContainer: {
      marginTop: "0px",
    },
    filterDiv: {
      marginLeft: "0px !important",
    },
  },
  "@media screen and (max-width: 472px)": {
    graphContainer: {
      flexDirection: "column",
      height: "auto",
      width: "100%",
      marginTop: "1rem",
      "& > *": {
        marginBottom: "1rem",
      },
    },
    table: {
      maxWidth: "100vw",
    },
  },
});

function TestCharts() {
  const isSmall = useMediaQuery({ query: "(max-width: 472px)" });
  const classes = useStyles();
  // const {userDetails} = useContext(GlobalContext);
  const [overAllData, setOverAllData] = React.useState(getLabel());
  const [timeSpent, setTimeSpent] = React.useState([]);
  const [testStatus, setTestStatus] = React.useState([
    { name: "Completed", value: 0 },
    { name: "Pending", value: 0 },
  ]);
  const [questionAttemptStatus, setQuestionAttemptStatus] = React.useState([
    { name: "Correct", value: 0 },
    { name: "Incorrect", value: 0 },
    { name: "Unattempted", value: 0 },
  ]);
  const [questionStatus, setQuestionStatus] = React.useState([]);
  const [testStatusGraph, setTestStatusGraph] = React.useState([]);
  const [difficultyChart, setDifficulty] = React.useState([]);
  const [subjectData, setSubjectData] = React.useState([]);
  const [cognitiveChart, setCognitveChart] = React.useState([]);
  const [learningStatus, setLearningStatus] = React.useState([]);
  const [tabContent, setTabContent] = React.useState([]);
  const [tabContent2, setTabContent2] = React.useState([]);
  const [testAssign, setTestAssign] = React.useState(0);
  const [disabled, setDisabled] = React.useState(false);
  const history = useHistory();
  const [headerData, setHeaderData] = React.useState({
    subject: "",
    chapter: "",
    topic: "",
  });
  const activeFilter = React.useRef("subjectId");
  const [loaders, setLoaders] = React.useState([
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
  ]);

  const [filterData, setFilterData] = React.useState({
    subjectId: "",
    chapterId: "",
    topicId: "",
  });
  const [formData, setFormData] = React.useState({
    startDate: "",
    endDate: "",
    subject: "",
  });

  //   console.log(filterData);

  const getOverAllData = async () => {
    let str;
    if (filterData.chapterId) {
      str = FilterByChapter.getData(filterData.subjectId, filterData.chapterId);
    } else if (filterData.subjectId) {
      str = FilterBySubject.getData(filterData.subjectId);
    } else {
      str = overAllAnalytics.getData;
    }

    await axios
      .get(str, {
        headers: {
          token: window.localStorage.getItem("authToken"),
        },
      })
      .then((res) => {
        let data = res.data.data.analytics[0];
        const dt = getLabel(
          data?.score,
          data?.gradeAvgScore,
          data?.attemptedTests,
          data?.totalTests,
          data?.attemptedQuestions,
          data?.totalQuestions,
          data?.timeTakenInTest,
          data?.avgTimeTakenInQues,
          data?.topics,
          data?.chapters,
        );

        setOverAllData([...dt]);
      })
      .catch((err) => console.log(err));
  };
  const getTimeSpent = async () => {
    let str;

    if (filterData.chapterId) {
      str = FilterByChapter.timeSpent(
        filterData.subjectId,
        filterData.chapterId,
      );
    } else if (filterData.subjectId) {
      str = FilterBySubject.timeSpent(filterData.subjectId);
    } else {
      str = overAllAnalytics.timeSpent;
    }
    await axios
      .get(str, {
        headers: {
          token: window.localStorage.getItem("authToken"),
        },
      })
      .then((res) => {
        let data = res.data.data.analytics;
        console.log(data);
        console.log(activeFilter);
        let temp = [];

        data.forEach((item) => {
          if (item?.[activeFilter.current]) {
            temp.push({
              Subject: item?.[activeFilter.current]?.name,
              Time: `${parseFloat(item?.timeTaken / (1000 * 60)).toFixed(2)}`,
              "time taken": `${Math.floor(
                item?.timeTaken / (1000 * 60),
              )}m ${Math.ceil((item?.timeTaken / 1000) % 60)}s`,
              subjectId: item?.[activeFilter.current]?._id,
            });
          }
        });
        setTimeSpent(() => [...temp]);
        loaders[0] = false;
        setLoaders(() => [...loaders]);
      })
      .catch((err) => console.log(err));
  };

  const getTestStatus = async () => {
    let str;

    if (filterData.chapterId) {
      str = FilterByChapter.getTestStatus(
        filterData.subjectId,
        filterData.chapterId,
      );
    } else if (filterData.subjectId) {
      str = FilterBySubject.getTestStatus(filterData.subjectId);
    } else {
      str = overAllAnalytics.getTestStatus;
    }
    await axios
      .get(str, {
        headers: {
          token: window.localStorage.getItem("authToken"),
        },
      })
      .then((res) => {
        let data = res.data.data.analytics;
        console.log(data);
        let temp1 = [];
        let temp2 = [
          { name: "Completed", value: 0 },
          { name: "Pending", value: 0 },
        ];

        data.forEach((item) => {
          if (item?.[activeFilter.current]) {
            temp1.push({
              Subject: item?.[activeFilter.current]?.name,
              Completed: item.completed,
              Pending: item.pending,
              subjectId: item?.[activeFilter.current]?._id,
            });
          }
        });
        let dt = 0;
        setTestStatusGraph(() => [...temp1]);
        data.forEach((item) => {
          dt += item.completed + item.pending;
          temp2[0].value += item.completed;
          temp2[1].value += item.pending;
        });
        setTestAssign(dt);
        loaders[1] = false;
        loaders[2] = false;
        setLoaders(() => [...loaders]);
        setTestStatus(() => [...temp2]);
      })
      .catch((err) => console.log(err));
  };
  const getQuestionAttemptStatus = async () => {
    let str;

    if (filterData.chapterId) {
      str = FilterByChapter.questionAttemptStatus(
        filterData.subjectId,
        filterData.chapterId,
      );
    } else if (filterData.subjectId) {
      str = FilterBySubject.questionAttemptStatus(filterData.subjectId);
    } else {
      str = overAllAnalytics.questionAttemptStatus;
    }

    await axios
      .get(str, {
        headers: {
          token: window.localStorage.getItem("authToken"),
        },
      })
      .then((res) => {
        let data = res.data.data.analytics;
        console.log(data);
        let temp1 = [];
        data.forEach((item) => {
          if (item?.[activeFilter.current]) {
            temp1.push({
              Subject: item?.[activeFilter.current].name,
              Correct: item.totalCorrect,
              Incorrect: item.totalIncorrect,
              Unattempted: item.totalUnattempted,
              subjectId: item?.[activeFilter.current]._id,
            });
          }
        });
        setQuestionStatus([...temp1]);
        let temp2 = [
          { name: "Correct", value: 0 },
          { name: "Incorrect", value: 0 },
          { name: "Unattempted", value: 0 },
        ];

        data.forEach((temp) => {
          temp2[0].value += temp.totalCorrect;
          temp2[1].value += temp.totalIncorrect;
          temp2[2].value += temp.totalUnattempted;
        });
        setQuestionAttemptStatus(() => [...temp2]);
        loaders[3] = false;
        loaders[4] = false;
        setLoaders(() => [...loaders]);
      })
      .catch((err) => console.log(err));
  };

  const getCorrectQuestionLevel = async () => {
    let str;

    if (filterData.chapterId) {
      str = FilterByChapter.correctQuestionLevel(
        filterData.subjectId,
        filterData.chapterId,
      );
    } else if (filterData.subjectId) {
      str = FilterBySubject.correctQuestionLevel(filterData.subjectId);
    } else {
      str = overAllAnalytics.correctQuestionLevel;
    }

    await axios
      .get(str, {
        headers: {
          token: window.localStorage.getItem("authToken"),
        },
      })
      .then((res) => {
        let data = res.data.data.analytics;
        let temp1 = [],
          temp2 = [];
        data.forEach((item) => {
          if (item?.[activeFilter.current]) {
            let subject = item?.[activeFilter.current].name;
            let subjectId = item?.[activeFilter.current]._id;
            let { cognitive, difficulty } = item;

            temp1.push({
              Subject: subject,
              Easy: difficulty.easy.correct,
              "Total Easy": difficulty.easy.total,
              Intermediate: difficulty.intermediate.correct,
              "Total Intermediate": difficulty.intermediate.total,
              Difficult: difficulty.hard.correct,
              "Total Difficult": difficulty.hard.total,
              subjectId,
            });

            temp2.push({
              Subject: subject,
              Analysis: cognitive.analysis.correct,
              "Total Analysis": cognitive.analysis.total,
              Application: cognitive.application.correct,
              "Total Application": cognitive.application.total,
              Knowledge: cognitive.knowledge.correct,
              "Total Knowledge": cognitive.knowledge.total,
              Understanding: cognitive.understanding.correct,
              "Total Understanding": cognitive.understanding.total,
            });
          }
        });
        setDifficulty(() => [...temp1.filter(item => item.Easy + item.Intermediate + item.Difficult > 0)]);
        setCognitveChart(() => [...temp2.filter(item => item.Analysis + item.Application + item.Knowledge + item.Understanding > 0)]);
        loaders[5] = false;
        loaders[6] = false;
        setLoaders(() => [...loaders]);
      })
      .catch((err) => console.log(err));
  };

  const getLearningStatus = async () => {
    let str;

    if (filterData.chapterId) {
      str = FilterByChapter.learningStatus(
        filterData.subjectId,
        filterData.chapterId,
      );
    } else if (filterData.subjectId) {
      str = FilterBySubject.learningStatus(filterData.subjectId);
    } else {
      str = overAllAnalytics.learningStatus;
    }

    await axios
      .get(str, {
        headers: {
          token: window.localStorage.getItem("authToken"),
        },
      })
      .then((res) => {
        let data = res.data.data.analytics;
        let temp = [];
        data.forEach((item) => {
          if (item?.[activeFilter.current]) {
            temp.push({
              Subject: item?.[activeFilter.current].name,
              Strength: item.strength,
              Gap: item.gap,
              subjectId: item?.[activeFilter.current]._id,
            });
          }
        });
        setLearningStatus([...temp]);
        loaders[7] = false;
        setLoaders(() => [...loaders]);
      })
      .catch((err) => console.log(err));
  };
  const getTestReports = async () => {
    let str;
    if (filterData.topicId) {
      str = FilterByTopic.testReports(
        filterData.subjectId,
        filterData.chapterId,
        filterData.topicId,
      );
    } else if (filterData.chapterId) {
      str = FilterByChapter.testReports(
        filterData.subjectId,
        filterData.chapterId,
      );
    } else if (filterData.subjectId) {
      str = FilterBySubject.testReports(filterData.subjectId);
    } else {
      str = overAllAnalytics.testReports;
    }

    await axios
      .get(str, {
        headers: {
          token: window.localStorage.getItem("authToken"),
        },
      })
      .then((res) => {
        let data = res.data.data.analytics;
        console.log(data);
        let temp = [];
        temp = data.map((item, idx) => {
          return {
            sno: idx + 1,
            startDate: new Date(item?.testId?.from).toLocaleDateString(),
            endDate: new Date(item?.testId?.to).toLocaleDateString(),
            subject: item?.subjectId?.name,
            subjectId: item?.subjectId?._id,
            chapter: item.chapters,
            topic: item.topics,
            testType: item.testType,
            date: new Date(item.startedAt).toLocaleDateString(),
            startTime: new Date(item.startedAt).toLocaleTimeString(),
            timeSpent: `${getHours(
              parseFloat(item?.timeSpent / (1000 * 60 * 60)).toFixed(2),
            )}`,
            marks: item.totalMarks,
            testId: item?.testId?._id,
            subId: item?.submissionId,
            marksObtained: item.totalScore,
            classAverage: item?.avgScore,
            correct: item.correct,
            inCorrect: item.incorrect,
            easy: item?.correctAttempt?.easy,
            medium: item?.correctAttempt?.intermediate,
            difficult: item?.correctAttempt?.hard,
            knowledge: item?.correctAttempt?.knowledge,
            understanding: item?.correctAttempt?.understanding,
            analysis: item?.correctAttempt?.analysis,
            application: item?.correctAttempt?.application,
          };
        });
        setTabContent([...temp]);
        setTabContent2([...temp]);
      })
      .catch((err) => console.log(err));
  };
  console.log(filterData);

  const getTimeSpentOfTest = async () => {
    await axios
      .get(
        FilterByTopic.timeSpent(
          filterData.subjectId,
          filterData.chapterId,
          filterData.topicId,
        ),
        {
          headers: {
            token: window.localStorage.getItem("authToken"),
          },
        },
      )
      .then((res) => {
        let data = res.data.data.analytics;
        let temp = [];
        console.log(data);
        data.forEach((item) => {
          if (item.testId) {
            temp.push({
              Subject: item?.testId?.questionSet?.title.split("_")[0],
              Time: parseFloat(item?.timeTaken / (1000 * 60)).toFixed(2),
            });
          }
          setTimeSpent(() => [...temp]);
          loaders[0] = false;
          setLoaders(() => [...loaders]);
        });
      })
      .catch((err) => console.log(err));
  };
  //   console.log(timeSpent);
  const getTestStatusOfTest = async () => {
    await axios
      .get(
        FilterByTopic.getTestStatus(
          filterData.subjectId,
          filterData.chapterId,
          filterData.topicId,
        ),
        {
          headers: {
            token: window.localStorage.getItem("authToken"),
          },
        },
      )
      .then((res) => {
        let data = res.data.data.analytics;
        let temp1 = [];
        let temp2 = [
          { name: "Completed", value: 0 },
          { name: "Pending", value: 0 },
        ];
        data?.forEach((item) => {
          if (item?.testId) {
            temp1.push({
              Subject: item?.testId?.questionSet?.title.split("_")[0],
              Completed: item.completed,
              Pending: item.pending,
              subjectId: item?.testId?._id,
            });
          }
        });
        setTestStatusGraph(() => [...temp1]);
        data.forEach((item) => {
          temp2[0].value += item.completed;
          temp2[1].value += item.pending;
        });

        setTestStatus(() => [...temp2]);
        loaders[1] = false;
        loaders[2] = false;
        setLoaders(() => [...loaders]);
      })
      .catch((err) => console.log(err));
  };

  const getQuestionAttemptStatusOfTest = async () => {
    await axios
      .get(
        FilterByTopic.questionAttemptStatus(
          filterData.subjectId,
          filterData.chapterId,
          filterData.topicId,
        ),
        {
          headers: {
            token: window.localStorage.getItem("authToken"),
          },
        },
      )
      .then((res) => {
        let data = res.data.data.analytics;
        console.log(data);
        let temp1 = [];
        // let temp2=[]
        data.forEach((item) => {
          if (item?.testId) {
            temp1.push({
              Subject: item?.testId?.questionSet?.title.split("_")[0],
              Correct: item.totalCorrect,
              Incorrect: item.totalIncorrect,
              Unattempted: item.totalUnattempted,
              subjectId: item?.testId?.questionSet?._id,
            });
          }
        });
        setQuestionStatus([...temp1]);
        let temp2 = [
          { name: "Correct", value: 0 },
          { name: "Incorrect", value: 0 },
          { name: "Unattempted", value: 0 },
        ];

        data.forEach((temp) => {
          temp2[0].value += temp.totalCorrect;
          temp2[1].value += temp.totalIncorrect;
          temp2[2].value += temp.totalUnattempted;
        });
        setQuestionAttemptStatus(() => [...temp2]);
        loaders[3] = false;
        loaders[4] = false;
        setLoaders(() => [...loaders]);
      });
  };

  const getCorrectQuestionLevelOfTest = async () => {
    await axios
      .get(
        FilterByTopic.correctQuestionLevel(
          filterData.subjectId,
          filterData.chapterId,
          filterData.topicId,
        ),
        {
          headers: {
            token: window.localStorage.getItem("authToken"),
          },
        },
      )
      .then((res) => {
        let data = res.data.data.analytics;
        let temp1 = [],
          temp2 = [];
        data.forEach((item) => {
          if (item?.testId?.questionSet) {
            let subject = item?.testId?.questionSet?.title.split("_")[0];
            let subjectId = item?.testId?._id;
            let { cognitive, difficulty } = item;

            // console.log(difficulty, cognitive);
            temp1.push({
              Subject: subject,
              Easy: difficulty.easy.correct,
              "Total Easy": difficulty.easy.total,
              Intermediate: difficulty.intermediate.correct,
              "Total Intermediate": difficulty.intermediate.total,
              Difficult: difficulty.hard.correct,
              "Total Difficult": difficulty.hard.total,
              subjectId,
            });

            temp2.push({
              Subject: subject,
              Analysis: cognitive.analysis.correct,
              "Total Analysis": cognitive.analysis.total,
              Application: cognitive.application.correct,
              "Total Application": cognitive.application.total,
              Knowledge: cognitive.knowledge.correct,
              "Total Knowledge": cognitive.knowledge.total,
              Understanding: cognitive.understanding.correct,
              "Total Understanding": cognitive.understanding.total,
            });
          }
        });
        setDifficulty(() => [...temp1]);
        setCognitveChart(() => [...temp2]);
        loaders[5] = false;
        loaders[6] = false;
        setLoaders(() => [...loaders]);
      })
      .catch((err) => console.log(err));
  };
  console.log(cognitiveChart);
  const getLearningStatusOfTest = async () => {
    await axios
      .get(
        FilterByTopic.learningStatus(
          filterData.subjectId,
          filterData.chapterId,
          filterData.topicId,
        ),
        {
          headers: {
            token: window.localStorage.getItem("authToken"),
          },
        },
      )
      .then((res) => {
        let data = res.data.data.analytics;
        let temp = [];
        data.forEach((item) => {
          if (item?.testId?.questionSet) {
            temp.push({
              Subject: item?.testId?.questionSet?.title.split("_")[0],
              Strength: item.strength,
              Gap: item.gap,
              subjectId: item?.testId?.questionSet?._id,
            });
          }
        });
        setLearningStatus([...temp]);
        loaders[7] = false;
        setLoaders(() => [...loaders]);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    const asyncFunction = async () => {
      setDisabled(true);
      if (filterData.topicId) {
        setLoaders([true, true, true, true, true, true, true, true]);
        activeFilter.current = "topicId";

        await getTimeSpentOfTest();
        await getTestStatusOfTest();
        await getQuestionAttemptStatusOfTest();
        await getCorrectQuestionLevelOfTest();
        await getLearningStatusOfTest();
        setDisabled(false);
      } else {
        if (filterData.chapterId) activeFilter.current = "topicId";
        else if (filterData.subjectId) activeFilter.current = "chapterId";
        else {
          activeFilter.current = "subjectId";
        }
        setLoaders([true, true, true, true, true, true, true, true]);
        await getOverAllData();
        await getLearningStatus();
        await getTestStatus();
        //await getTimeSpent();
        await getQuestionAttemptStatus();
        await getCorrectQuestionLevel();
        await getTestReports();
        setDisabled(false);
      }
    };
    asyncFunction();
  }, [filterData]);

  useEffect(() => {
    let tabData = tabContent2;
    if (formData.startDate) {
      tabData = tabData.filter(
        (item, idx) =>
          new Date(item?.startDate) >= new Date(formData?.startDate),
      );
    }
    if (formData.endDate) {
      tabData = tabData.filter(
        (item, idx) => new Date(item?.endDate) <= new Date(formData?.endDate),
      );
    }
    if (formData.subject) {
      console.log(formData);
      console.log(tabData);
      tabData = tabData.filter(
        (item) => item.subject === formData.subject.name,
      );
    }
    setTabContent(() =>
      tabData.map((item, idx) => {
        return { ...item, sno: idx + 1 };
      }),
    );
  }, [formData]);

  const subtitle = useMemo(() => {
    if (!headerData) return "";
    const parts = [
      headerData.subject,
      headerData.chapter,
      headerData.topic,
    ].filter(Boolean); // removes undefined/null/empty

    return parts.join(" > ");
  }, [headerData]);

  return (
    <>
      <SideBoard
        filterData={filterData}
        setFilterData={setFilterData}
        type="online"
        setSubjectData={setSubjectData}
        headerData={headerData}
        setData={setHeaderData}
        disabled={disabled}
      ></SideBoard>

      <AnalyticsSection>
        {!isSmall ? (
          <AnalyticsHeader
            title={"Online Test Analytics"}
            background="linear-gradient(91.91deg, #C08497 1.44%, #B46A81 99.96%)"
            subtitle={subtitle}
          />
        ) : (
          ""
        )}
        <br/>
        <MiniCards data={overAllData} />
        <br/>
        <AnalyticsGrid>
          <LearningStrength data={learningStatus} loading={loaders[7]} />
          <TestStatusPieChart data={testStatus} loading={loaders[1]} />
          <ResourceWiseQuestionAttemptAnalysis data={questionStatus} loading={loaders[4]} />
          <OverallQuestionAttemptAnalysis
            data={questionAttemptStatus}
            loading={loaders[2]}
          />
          <DifficultyReport data={difficultyChart} loading={loaders[5]} />
          <CognitiveReport data={cognitiveChart} loading={loaders[6]} />
          {/*<TimePerSubject tests={testAssign} data={timeSpent} loading={loaders[0]} />*/}
          <TestStatus data={testStatusGraph} loading={loaders[3]} />
        </AnalyticsGrid>

        <OnlineTestLists
          classes={classes}
          headers={OnlineTest}
          rows={tabContent}
          subjectData={subjectData}
          setFormData={setFormData}
          formData={formData}
        />
      </AnalyticsSection>
      <ScrollTop />
    </>
  );
}

export default TestCharts;
